import React, { useEffect } from 'react';
import WorldMap from './Dashboard/WorldMap';

const TestAnalytics = () => {
  // Mock data for testing WorldMap component
  const mockCountryData = [
    {country: "US", total_revenue: 61001.51, total_transactions: 1463},
    {country: "CR", total_revenue: 22181.43, total_transactions: 694},
    {country: "HN", total_revenue: 1464.48, total_transactions: 4},
    {country: "CO", total_revenue: 1310.40, total_transactions: 10},
    {country: "SV", total_revenue: 838.94, total_transactions: 43},
    {country: "CA", total_revenue: 530.49, total_transactions: 7},
    {country: "GB", total_revenue: 282.43, total_transactions: 5},
    {country: "PA", total_revenue: 202.83, total_transactions: 1},
    {country: "MX", total_revenue: 200.80, total_transactions: 3},
    {country: "CH", total_revenue: 192.26, total_transactions: 2}
  ];

  useEffect(() => {
    console.log('🔍 TestAnalytics component mounted');
    console.log('📊 Mock data loaded:', mockCountryData);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">WorldMap Geography Debug Test</h1>
        <p className="text-gray-600 mb-8">Testing WorldMap component with mock data to identify country code mapping issues.</p>
        
        <WorldMap 
          countryData={mockCountryData}
          currency="all"
          selectedCountry={null}
          onCountrySelect={(country) => console.log('Country selected:', country)}
        />
        
        <div className="mt-8 p-4 bg-white rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4">Expected Debug Output:</h2>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>• CountryDataMap created with 10 countries</li>
            <li>• CountryDataMap keys: ["USA", "CRI", "HND", "COL", "SLV", "CAN", "GBR", "PAN", "MEX", "CHE"]</li>
            <li>• Geography Country Debug logs for USA, CRI, HND, COL</li>
            <li>• Countries should be colored based on revenue data</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestAnalytics;